import axios from 'axios'
export interface ApiError {
  status: number
  message: string
  data?: unknown
  isNetworkError?: boolean
  isAuthError?: boolean
}

export interface ApiResponse<T = unknown> {
  data: T
  status: number
}

const publicInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

// Request interceptor
publicInstance.interceptors.request.use(
  (config) => {
    if (import.meta.env.DEV) {
      console.log('📡 Public API Request:', {
        url: `${config.baseURL}${config.url}`,
        method: config.method?.toUpperCase(),
      })
    }
    return config
  },
  (error) => Promise.reject(error),
)

// Response interceptor
publicInstance.interceptors.response.use(
  (response) => {
    if (import.meta.env.DEV) {
      console.log('✅ Public API Response:', {
        url: response.config.url,
        status: response.status,
      })
    }
    return response
  },
  (error) => {
    const apiError: ApiError = {
      status: error.response?.status || 0,
      message: error.response?.data?.message || 'An error occurred',
      data: error.response?.data,
      isNetworkError: !error.response,
    }

    if (import.meta.env.DEV) {
      console.error('❌ Public API Error:', apiError)
    }

    return Promise.reject(apiError)
  },
)

export default publicInstance
